import './BreathingExercise.scss'

import { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom'

import { ROUTE_ACTIVITIES_BREATHING_ALL } from '../../../common/helpers/Paths'
import useFetchByID from '../../../common/hooks/useFetchByID'
import { getBreathingData } from '../../../common/api/Practices'
import BreathingExerciseOrb from '../BreathingExerciseOrb'

export default function BreathingExercise({
  cache,
  setHeaderTitle,
  setReturnPath
}) {
  const { breathingId, breathingVideoMinute } = useParams()

  const cacheKey = `${ROUTE_ACTIVITIES_BREATHING_ALL}/intro/${breathingId}`
  const { data } = useFetchByID(getBreathingData, breathingId, cache, cacheKey)

  const breathingData = data?.acf

  // For how many minutes does the user want to practice?
  const practiceMinutes = parseInt(breathingVideoMinute) ?? 1 // Default to 1 minute

  // Start the animation when the component mounts
  useEffect(() => {
    // Return early if we don't have breathing data
    if (!breathingData) return

    // Set the header title and return path
    setHeaderTitle(null)
    setReturnPath(`${ROUTE_ACTIVITIES_BREATHING_ALL}/intro/${breathingId}`)
  }, [breathingId, breathingData, setHeaderTitle, setReturnPath])

  // Return early if we don't have data
  if (!breathingData) return null

  return (
    <>
      <Container className='w-100 px-0 pb-0 orb-container'>
        {practiceMinutes && breathingData && (
          <BreathingExerciseOrb
            practiceMinutes={practiceMinutes}
            breathingData={breathingData}
            returnPath={`${ROUTE_ACTIVITIES_BREATHING_ALL}/intro/${breathingId}`}
          />
        )}
      </Container>
    </>
  )
}
